import { Injectable } from '@angular/core';
import { NamespaceView } from '@core/models/namespaceView.interface';

@Injectable({
  providedIn: 'root'
})
export class ActiveNamespaceService {

  getNamespace(): NamespaceView | null {
    const activeNamespace = localStorage.getItem('namespace');
    return activeNamespace ? JSON.parse(activeNamespace) : null;
  }
  
  getNamespaceId(): string {
    const activeNamespace = this.getNamespace();
    return activeNamespace ? activeNamespace.id : '';
  }

  setNamespace(namespace: NamespaceView): void {
   localStorage.setItem('namespace', JSON.stringify(namespace));
  }

}
